import * as watchUtils from "@arcgis/core/core/watchUtils";
/**@category utilities */
export function mapClickEvent(mapView, callback) {
    mapView.on('click', async (event) => {
        mapView.hitTest(event, { exclude: mapView.graphics }).then(function (response) {
            callback({ response: response, event: event });
        });
    });
}
/**@category utilities */
export function addWatchEventOnMap(mapView, callbackWhenFalseOnce) {
    watchUtils.whenTrue(mapView, "stationary", function () {
        watchUtils.whenFalseOnce(mapView, "updating", () => {
            callbackWhenFalseOnce(mapView);
        });
    });
}
